import { suppliersTableColumnDefinitions } from '../constants/suppliersTableColumnDefinitions'
import { SuppliersTableHideableColumnKey } from '../types/suppliersTableHideableColumnKey'

const suppliersTableHideableColumnKeys = new Set<string>(
  suppliersTableColumnDefinitions
    .filter((column) => 'hideable' in column && column.hideable)
    .map((column) => column.key),
)

export const isSuppliersTableHideableColumnKey = (key: string): key is SuppliersTableHideableColumnKey =>
  suppliersTableHideableColumnKeys.has(key)
